import { useMemo } from 'react'

import { SmartLinkPattern, parseSmartLinkString } from 'components/MCTextEditor/smartLinks/adapter'

const SmartLinksRegexp = new RegExp(`\\n?(${SmartLinkPattern})\\n?`, 'g')

export enum ContentPartType {
  TEXT = 'text',
  BUTTON = 'button',
}

export interface ContentTextPart {
  type: ContentPartType.TEXT
  text: string
}

export interface ContentButtonPart {
  type: ContentPartType.BUTTON
  buttonId: string
}

export type ContentPart = ContentTextPart | ContentButtonPart

export const useTextContentParts = (
  text: string,
): {
  textContent: ContentPart[]
  smartLinkButtonIdsMap: Map<string, true>
} => {
  const { smartLinkButtonIdsMap, textContent } = useMemo(() => {
    const smartLinkButtonIdsMap: Map<string, true> = new Map()
    const textContent: ContentPart[] = text
      .split(SmartLinksRegexp)
      .reduce((acc: ContentPart[], textOrLink, index) => {
        if (index % 2 === 0 && Boolean(textOrLink) && textOrLink.trim() !== '') {
          acc.push({ type: ContentPartType.TEXT, text: textOrLink })
          return acc
        }

        const buttonId = parseSmartLinkString(textOrLink)
        if (buttonId) {
          smartLinkButtonIdsMap.set(buttonId, true)
          acc.push({ type: ContentPartType.BUTTON, buttonId })
        }

        return acc
      }, [])

    return { smartLinkButtonIdsMap: smartLinkButtonIdsMap, textContent }
  }, [text])
  return { smartLinkButtonIdsMap, textContent }
}
